import type { EntitySummary } from '../types/entities';

function ids(value: unknown) {
  return Array.isArray(value) ? value.filter((item): item is string => typeof item === 'string') : [];
}

/** Shared narrative context for every entity search result. */
export function storySearchContext(entities: EntitySummary[], entity: EntitySummary) {
  if (entity.templateCategory === 'orte' && (entity.locationPath?.length ?? 0) > 1) return entity.locationPath!.slice(0, -1).map((place) => place.title).join(' → ');
  if (entity.searchContext) return entity.searchContext;
  if (entity.templateCategory !== 'szene') return null;
  const chapter = entities.find((candidate) => candidate.templateCategory === 'kapitel'
    && ids(candidate.fieldValues?.scenes).includes(entity.id));
  return chapter ? `Kapitel · ${chapter.title}` : 'Ohne Kapitel';
}
